export default __webpack_public_path__ + "static/media/jumpStarter-removebg-preview.c02ba006.png";